import React, { FunctionComponent } from 'react'
import { Route, Switch, Redirect, RouteComponentProps } from 'react-router-dom'

import { DashboardContainer, UserContainer } from '../../containers'

import { AppContainer, LinkInfoContainer } from '../../containers/old'

import { Err401, Err404 } from '../../components'
import AdvertisersRouter from './old/advertisers'
import AlertsRouter from './old/alerts'
import SupportRouter from './support'
import WebsitesRouter from './old/websites'
import MyFiReportsRouter from './myfiReports'

// TODO: Remove after transition to GQL-reports
import LinksRouter from './old/links'
import BannerReferralsRouter from './old/bannerReferrals'
import PaymentsRouter from './old/payments'
import ReportsRouter from './old/reports'
import AppUsersRouter from './old/appUsers'

import RestrictedRoute from '../util/RestrictedRoute'

const AppRouter: FunctionComponent<RouteComponentProps> = ({ match }) => {
  return (
    <AppContainer>
      <Switch>
        <Redirect exact path={match.path} to="/app/dashboard" />
        <Route path={`${match.path}/unauthorized`} render={() => <Err401 />} />
        <RestrictedRoute
          path={`${match.path}/dashboard`}
          component={DashboardContainer}
        />
        <RestrictedRoute
          path={`${match.path}/advertisers`}
          render={AdvertisersRouter}
        />
        <RestrictedRoute path={`${match.path}/links`} component={LinksRouter} />
        <RestrictedRoute
          path={`${match.path}/link-info`}
          component={LinkInfoContainer}
        />
        <RestrictedRoute
          path={`${match.path}/reports`}
          component={ReportsRouter}
        />
        <RestrictedRoute
          path={`${match.path}/banner-referrals`}
          component={BannerReferralsRouter}
        />
        <RestrictedRoute
          path={`${match.path}/payments`}
          minimumRequiredRole="admin"
          component={PaymentsRouter}
        />
        <RestrictedRoute
          path={`${match.path}/myfi-reports`}
          component={MyFiReportsRouter}
        />
        <RestrictedRoute
          path={`${match.path}/alerts`}
          component={AlertsRouter}
        />
        <RestrictedRoute
          path={`${match.path}/support`}
          component={SupportRouter}
        />
        <RestrictedRoute
          path={`${match.path}/websites`}
          component={WebsitesRouter}
        />
        <RestrictedRoute
          path={`${match.path}/users`}
          minimumRequiredRole="manager"
          component={AppUsersRouter}
        />
        <RestrictedRoute
          path={`${match.path}/profile`}
          component={UserContainer}
        />
        <Route render={() => <Err404 isInternal />} />
      </Switch>
    </AppContainer>
  )
}

export default AppRouter
